export default __webpack_public_path__ + "static/firstview-sp-e8e5be2f6fc96e61505a1ad20c0e85da.jpg";